import React, { Fragment } from 'react'
import {
    Create,
    TextInput,
    BooleanInput,
    NumberInput
} from 'react-admin'

import Title from '../Generic/Title'
import { CustomSimpleForm } from '../Generic'

export const CategoriaVUCreate = ({ permissions, ...props }) => {
    if (permissions === null) {
        return null
    }
    return (
        <Fragment>
            <Title title={"Crear Categoria Vida Útil"} />
            <Create {...props}>
                <CustomSimpleForm>
                    <NumberInput source="id" disabled={true} />
                    <TextInput source="name" />
                    <TextInput source="description" />
                    <NumberInput source="vida_util" />
                    <BooleanInput source="active" />
                </CustomSimpleForm>
            </Create>
        </Fragment>
    )
};

